import localforage from 'localforage';

export const LOCAL_FORAGE_NAME = 'storage';
export const LOCAL_FORAGE_STORE_NAME = 'data';

localforage.config({
  name: LOCAL_FORAGE_NAME,
  storeName: LOCAL_FORAGE_STORE_NAME,
});

export const saveFormData = async (key: string, data: any) => {
  await localforage.setItem(key, data);
};

export const loadFormData = async <T>(key: string) => {
  return localforage.getItem<T>(key);
};

export const removeFormData = async (key: string) => {
  await localforage.removeItem(key);
};
